/**
 * Mobile purchase entry points kept under the old names so sign-in and
 * billing call sites stay stable.
 * Purchases run through StoreKit / Play Billing (`storeBilling`), then the
 * backend verifies the store transaction. These identity hooks are no-ops:
 * the store account token comes from `/monetization/subscription/`.
 */
import { decodeJwtPayload } from '../auth/jwtHelpers';
import { getAccessToken } from '../auth/tokenStorage';

type AccountLike = { id?: number | string | null };

/** Prefer numeric user pk; fall back to JWT `user_id` claim. */
export function resolveAppUserId(account?: AccountLike | null): string | null {
  if (account?.id != null && String(account.id).trim() !== '') {
    return String(account.id);
  }
  const token = getAccessToken();
  if (!token) return null;
  const payload = decodeJwtPayload(token) as { user_id?: number | string } | null;
  if (payload?.user_id != null && String(payload.user_id).trim() !== '') {
    return String(payload.user_id);
  }
  return null;
}

export async function logInRevenueCat(
  _appUserIdOrAccount?: string | AccountLike | null
): Promise<void> {
  return;
}

export async function logOutRevenueCat(): Promise<void> {
  return;
}

export async function purchasePlan(planSlug?: string): Promise<void> {
  const { purchaseNativePlan } = await import('./storeBilling');
  return purchaseNativePlan(planSlug);
}

export async function restorePurchases(): Promise<void> {
  const { restoreNativePurchases } = await import('./storeBilling');
  return restoreNativePurchases();
}

export function isPurchaseCancelledError(error: unknown): boolean {
  const err = error as {
    userCancelled?: boolean;
    code?: number | string;
    message?: string;
    data?: { userCancelled?: boolean };
  };
  if (err?.userCancelled === true || err?.data?.userCancelled === true) return true;
  if (err?.code === 1 || err?.code === '1' || err?.code === 'PURCHASE_CANCELLED') {
    return true;
  }
  return typeof err?.message === 'string' && /purchase cancelled/i.test(err.message);
}
